<template>

    <b-modal id="my-quizzes-game-modal" centered>
        <template #modal-title>{{ modalTitle }}</template>

        <div class="step-1" v-if="step === 1">

            <div class="row">
                <div class="col-3">
                    <div class="mechanism-tile" :class="{'selected': form.mechanism === 'assoc'}" @click="form.mechanism = 'assoc'">
                        <img src="/assets/images/my-quizzes-assoc-tile.png" alt="">
                        <div class="bottom-bar">
                            <div class="name">{{ t.__('Skojarzenia') }}</div>
                            <div class="icon"></div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="mechanism-tile" :class="{'selected': form.mechanism === 'carousel'}" @click="form.mechanism = 'carousel'">
                        <img src="/assets/images/my-quizzes-carousel-tile.png" alt="">
                        <div class="bottom-bar">
                            <div class="name">{{ t.__('Karuzela pytań') }}</div>
                            <div class="icon"></div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="mechanism-tile" :class="{'selected': form.mechanism === 'qball'}" @click="form.mechanism = 'qball'">
                        <img src="/assets/images/my-quizzes-qball-tile.png" alt="">
                        <div class="bottom-bar">
                            <div class="name">{{ t.__('Piłka nożna - quiz') }}</div>
                            <div class="icon"></div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="mechanism-tile" :class="{'selected': form.mechanism === 'ships'}" @click="form.mechanism = 'ships'">
                        <img src="/assets/images/my-quizzes-ships-tile.png" alt="">
                        <div class="bottom-bar">
                            <div class="name">{{ t.__('Statki') }}</div>
                            <div class="icon"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-5">
                    <carousel :scrollPerPage="true" :perPage="1">
                        <slide v-for="screenshotSrc in mechanismData[form.mechanism].screenshots" :key="screenshotSrc" class="w-100">
                            <img :src="screenshotSrc" class="w-100" alt="">
                        </slide>
                    </carousel>
                </div>
                <div class="col-sm-7">
                    <p>{{ mechanismData[form.mechanism].name }}</p>
                    <p>{{ mechanismData[form.mechanism].description }}</p>
                </div>
            </div>

        </div>

        <div class="step-2" v-if="step === 2">

            <div class="row">
                <div class="col-md-4">

                    <div class="form-group">
                        <legend>{{ t.__('Ikona') }}</legend>
                        <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="240/320" :width="300"></file-manager-image-select>
                    </div>

                </div>
                <div class="col-md-8">

                    <b-form-group
                        id="my-quizzes-add-game-display-name-group"
                        description=""
                        :label="t.__('Nazwa wyświetlana')"
                        :disabled="processing"
                        valid-feedback=""
                        :invalid-feedback="form.errors.get('display_name')"
                        :state="form.errors.state('display_name')">
                        <b-form-input id="my-quizzes-game-set-display-name" v-model="form.display_name" :state="form.errors.state('display_name')" trim></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="my-quizzes-add-game-display-description-group"
                        description=""
                        :label="t.__('Opis wyświetlany (max. 200 znaków)')"
                        :disabled="processing"
                        valid-feedback=""
                        :invalid-feedback="form.errors.get('display_description')"
                        :state="form.errors.state('display_description')">
                        <b-form-textarea id="my-quizzes-add-game-display-description" v-model="form.display_description" max="200" :state="form.errors.state('display_description')" trim></b-form-textarea>
                    </b-form-group>

                </div>
            </div>

        </div>

        <template #modal-footer>
            <b-button variant="secondary" @click="close" v-text="action === 'add' ? t.__('Anuluj') : t.__('Zamknij')" :disabled="processing"></b-button>
            <b-button variant="success" v-if="action === 'add'" @click="next" :disabled="processing" v-text="processing ? t.__('Zapisuję...') : (step === 1 ? t.__('Dalej') : t.__('Zapisz'))"></b-button>
        </template>
    </b-modal>

</template>

<script>

import {Carousel, Slide} from 'vue-carousel';

export default {

    name: 'MyQuizzesGameModal',

    components: {
        Carousel,
        Slide
    },

    data() {
        return {
            eventHub: window.eventHub,
            action: null,
            step: 1,
            mechanismData: {
                assoc: {
                    name: t.__('Skojarzenia'),
                    description: t.__('Pomyśl chwilę i wybierz odpowiedź, która najbardziej j kojarzy Ci się z przedstawionymi trzema informacjami. Wygrywa osoba, która prawidłowo odpowie na największą liczbę skojarzeń.'),
                    screenshots: [
                        '/assets/images/mechanisms-screenshots/assoc/assoc-1.png',
                        '/assets/images/mechanisms-screenshots/assoc/assoc-2.png',
                        '/assets/images/mechanisms-screenshots/assoc/assoc-3.png'
                    ]
                },
                carousel: {
                    name: t.__('Karuzela pytań'),
                    description: t.__('W kształt koła wpisane są różnokolorowe pola, pod którymi kryją się pytania. Wylosuj tematykę pytania, a następnie wskaż prawidłową odpowiedź. Liczy się czas. Jeśli odpowiesz dobrze, otrzymujesz punkt.'),
                    screenshots: [
                        '/assets/images/mechanisms-screenshots/carousel/carousel-1.png',
                        '/assets/images/mechanisms-screenshots/carousel/carousel-2.png',
                        '/assets/images/mechanisms-screenshots/carousel/carousel-3.png'
                    ]
                },
                qball: {
                    name: t.__('Piłka nożna - quiz'),
                    description: t.__('Wygraj mecz piłki nożnej! Odpowiedz jak najszybciej na zadane pytanie, a piłka zmieni kierunek lub przyśpieszy w stronę bramki przeciwnika. Kto pierwszy ten lepszy!'),
                    screenshots: [
                        '/assets/images/mechanisms-screenshots/qball/qball-1.png',
                        '/assets/images/mechanisms-screenshots/qball/qball-2.png'
                    ]
                },
                ships: {
                    name: t.__('Statki'),
                    description: t.__('Zatop statek przeciwnika. Wybierz poziom trudności i pytania, a następnie wskaż prawidłową odpowiedź, aby oddać strzał. W trakcie strzału przeciwnika Twój partner może Cię uratować odpowiadając na pytanie dodatkowe. Podczas każdej rozgrywki możesz wybrać poziom trudności pytania. Odpowiadając na trudniejsze pytanie, szybciej zbliżasz się do wygranej.'),
                    screenshots: [
                        '/assets/images/mechanisms-screenshots/ships/ships-1.png',
                        '/assets/images/mechanisms-screenshots/ships/ships-2.png',
                        '/assets/images/mechanisms-screenshots/ships/ships-3.png'
                    ]
                }
            },
            form: new Vue.prototype.Form({
                set_output_identification_name: null,
                mechanism: 'assoc',
                display_name: null,
                display_description: null,
                icon: null
            }),
            processing: false

        }
    },

    computed: {

      modalTitle() {
          return this.action === 'add' ? t.__('Dodaj grę') : t.__('Zobacz mechanizmy')
      },

    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-add-game', (set) => {
            this.action = 'add';
            this.form.set_output_identification_name = set.output_identification_name;
            this.$bvModal.show('my-quizzes-game-modal')
        });

        this.eventHub.$on('my-quizzes-show-mechanisms', (mechanism = null) => {
            if (mechanism.length) {
                this.form.mechanism = mechanism;
            }
            this.action = 'show';
            this.$bvModal.show('my-quizzes-game-modal')
        });

        this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-game-modal') {
                Vue.nextTick(() => window.dispatchEvent(new Event('resize')));
            }
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-game-modal') {
                this.action = null;
                this.form.setData({
                    set_output_identification_name: null,
                    mechanism: 'assoc',
                    display_name: null,
                    display_description: null,
                    icon: null
                });
                this.step = 1;
                this.processing = false;
            }
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-game-modal');
        },

        next() {

            if (this.step === 1) {
                this.step = 2;
            } else {
                this.processing = true;
                this.form.post('/my-quizzes/store-game')
                    .then(response => {
                        this.eventHub.$emit('my-quizzes-update-sets', response.sets);
                        this.close();
                    })
                    .catch(error => {
                        console.log(error);
                        this.processing = false;
                    });
            }
        }

    }

}

</script>

<style scoped>

</style>
